export const environment = {
  production: true,
  URL_MASTER: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/LYWCBAXGTW/',
  URL_COMISSION: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/MEHDKYQVAW/',
  URL_CONTENT: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/JQFZDWVVLN/',
  URL_EXTERNAL: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/JRDGSLTQHN/',
  URL_PROFILE: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/HAKUBMQPYR/',
  URL_REFERAL: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/DSXTDWKLTV/',
  URL_SECURITY: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/UVCGDWUHSS/',
  URL_REPORTS: 'https://galioqa.grupo-exito.com/apiew/clickam/v1/FTJFPESUDT/',
  // URL_MASTER: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/LYWCBAXGTW/',
  // URL_COMISSION: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/MEHDKYQVAW/',
  // URL_CONTENT: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/JQFZDWVVLN/',
  // URL_EXTERNAL: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/JRDGSLTQHN/',
  // URL_PROFILE: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/HAKUBMQPYR/',
  // URL_REFERAL: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/DSXTDWKLTV/',
  // URL_SECURITY: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/UVCGDWUHSS/',
  // URL_REPORTS: 'https://wolframio.grupo-exito.com/apiew/clickam/v1/FTJFPESUDT/',
  URL_BLOB: 'https://webclickamqa.blob.core.windows.net/',

  GOOGLE_SIGNIN_CLIENT_ID: '445428889054-3gormdckigeabt70v1bf5vmuhint1cpu.apps.googleusercontent.com',
  FACEBOOK_SIGNIN_APP_ID: '684475756630473',
  
  DOMAIN: 'https://webclickamqa.z13.web.core.windows.net',
  firebaseConfig: {
    apiKey: 'AIzaSyAqrpI8Yw4m0fOL41SWVrENCBL2XRs4BIY',
    authDomain: 'clickam.firebaseapp.com',
    databaseURL: 'https://clickam.firebaseio.com',
    projectId: 'clickam',
    storageBucket: 'clickam.appspot.com',
    messagingSenderId: '707631941836',
    appId: '1:707631941836:web:5a94156b29c8fe2740da69',
  },

};
